import Axios from "../../services/axios-service";

const getAlertTypes = data => {
  return Axios.get("/api/AlertTypes?search=" + encodeURIComponent(JSON.stringify(data)));
};

export default {
  getAlertTypes
};
